var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 16.5V31.5C37.5 36 35.25 39 30 39H18C12.75 39 10.5 36 10.5 31.5V16.5C10.5 12 12.75 9 18 9H30C35.25 9 37.5 12 37.5 16.5Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 19.875H30.75C28.47 19.875 26.625 18.03 26.625 15.75V12.75C26.625 12.135 27.135 11.625 27.75 11.625C28.365 11.625 28.875 12.135 28.875 12.75V15.75C28.875 16.785 29.715 17.625 30.75 17.625H33.75C34.365 17.625 34.875 18.135 34.875 18.75C34.875 19.365 34.365 19.875 33.75 19.875Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 32.6252C20.7152 32.6252 20.4302 32.5202 20.2052 32.2952L17.2052 29.2952C16.7702 28.8602 16.7702 28.1402 17.2052 27.7052L20.2052 24.7052C20.6402 24.2702 21.3602 24.2702 21.7952 24.7052C22.2302 25.1402 22.2302 25.8602 21.7952 26.2952L19.5902 28.5002L21.7952 30.7052C22.2302 31.1402 22.2302 31.8602 21.7952 32.2952C21.5702 32.5202 21.2852 32.6252 21.0002 32.6252Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 32.6252C26.7152 32.6252 26.4302 32.5202 26.2052 32.2952C25.7702 31.8602 25.7702 31.1402 26.2052 30.7052L28.4102 28.5002L26.2052 26.2952C25.7702 25.8602 25.7702 25.1402 26.2052 24.7052C26.6402 24.2702 27.3602 24.2702 27.7952 24.7052L30.7952 27.7052C31.2302 28.1402 31.2302 28.8602 30.7952 29.2952L27.7952 32.2952C27.5702 32.5202 27.2852 32.6252 27.0002 32.6252Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCode);
export default __webpack_public_path__ + "static/media/documentCode.bfb2f04fc2e461d1f5dd5c9d3cf73ca2.svg";
export { ForwardRef as ReactComponent };